import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const dateTo = createTaskFilterFunction('dt', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  return !!filters.dt && task.start_display <= filters.dt
})
